import cloudRender from './index'
/**
 * @description: 模型树节点类型的枚举
 * @param {*}
 * @return {*}
 */

const modelTreeObj = {
  ITEM_PR: 0, // PR 文件节点类型
  ITEM_NODE: 1, // CELLNode文件节点类型
  ITEM_GISOBJ: 2, // gis 数据对象
  ITEM_NULL: 3, // 仅仅对根节点使用
}

/**
 * @description: 控制模型中部件的显示隐藏
 * @param {*} status
 * @param {*} isChecked
 * @param {*} selectInfo
 * @param {*} checkeds
 * @return {*}
 */
const setModelVisible = async (
  player,
  status,
  isChecked = true,
  selectInfo = {},
  modelTreeProp = {
    currentNodeItem: 0, // 当前激活的node
    currentNodeName: '', // 点选时当前激活的节点名称
    treeData: [], // 模型树数据
    defaultCheckedKey: [], // 模型树选中的节点
    filterItem: [], // 模型树不需要显示的节点及他的父节点列表
    modelHideList: [], // 模型隐藏队列
    modelTreeLoadEnd: false, // 模型树数据加载完毕
  },
  checkeds
) => {
  if (_.isEmpty(selectInfo)) {
    // 获取当前点选的对象
    selectInfo = cloudRender.Node.getSelectedItem(player)
  }
  const itemList = _.map(modelTreeProp.modelHideList, (el) => {
    return el.item
  })
  // ###################
  const rootItems = await player.Native.ModelTree.getRootItems()
  // 删除地球GIS层
  const rootItemsList = _.map(
    _.filter(rootItems, (item) => {
      return item.itemType === modelTreeObj.ITEM_PR || item.itemType === modelTreeObj.ITEM_NODE
    }),
    (el) => {
      return el.item
    }
  )
  switch (status) {
    case 'system.ToolShowModel':
      // 显示上一个(隐藏模型列表弹出最后一个，隐藏最后一个，默认框选中的列表添加弹出的最后一个)
      if (modelTreeProp.modelHideList.length > 0 && !modelTreeProp.spaceSwapStatus) {
        cloudRender.Node.setItemStatus(
          player,
          modelTreeProp.modelHideList[modelTreeProp.modelHideList.length - 1].item,
          isChecked
        )
        modelTreeProp.defaultCheckedKey.push(
          modelTreeProp.modelHideList[modelTreeProp.modelHideList.length - 1].item
        )
        modelTreeProp.filterItem.splice(
          modelTreeProp.filterItem.indexOf(
            modelTreeProp.modelHideList[modelTreeProp.modelHideList.length - 1].item
          ),
          1
        )
        modelTreeProp.modelHideList.pop()
      }
      break
    case 'system.ToolShowAll':
      // 显示全部隐藏（根据上面获取的跟节点之间都设置为true，清空隐藏模型列表，默认框选中的列表加上隐藏模型列表）
      cloudRender.Node.setItemStatus(player, rootItemsList, isChecked)
      // 去重
      modelTreeProp.defaultCheckedKey = [
        ...new Set([...modelTreeProp.defaultCheckedKey, ...modelTreeProp.filterItem]),
      ]
      modelTreeProp.filterItem = []
      modelTreeProp.modelHideList = []
      modelTreeProp.spaceSwapStatus = false
      break
    case 'system.ToolHideModel':
      // 隐藏选中节点（把当前要隐藏的项添加到隐藏模型列表中，设置当前项隐藏状态，当前项以及其子孙节点都应该从默认框选中列表中除去）
      if (_.last(modelTreeProp.filterItem) === selectInfo.item) return
      modelTreeProp.modelHideList.push(selectInfo)
      cloudRender.Node.setItemStatus(player, selectInfo.item, false)
      modelTreeProp.filterItem.push(selectInfo.item)
      // 获取选中的selectInfo的父级selfId
      let parentInfo = await cloudRender.Node.getInfo(player, 'Item', selectInfo.parentItem)
      modelTreeProp.filterItem.push(parentInfo.item)
      // 如果不为最外层包裹层
      if (parentInfo.selfId) {
        while (parentInfo.selfId !== 1) {
          // eslint-disable-next-line no-await-in-loop
          parentInfo = await cloudRender.Node.getInfo(player, 'Item', parentInfo.parentItem)
          modelTreeProp.filterItem.push(parentInfo.item)
        }
      }
      const result = await cloudRender.Node.findItemChild(player, selectInfo.item)
      const subItems = result.data
      // 去重放在报错之后，多push了几次进去
      modelTreeProp.filterItem = [
        ...new Set([
          ...modelTreeProp.filterItem,
          ..._.map(subItems, (res) => {
            return res.item
          }),
        ]),
      ]
      modelTreeProp.defaultCheckedKey = _.filter(modelTreeProp.defaultCheckedKey, (el) => {
        return modelTreeProp.filterItem.indexOf(el) === -1
      })
      break
    case 'system.ToolHideModelSpaceSwap':
      // 隐藏模型，显示隐藏列表（将默认框选中的列表等于隐藏模型列表，上一次隐藏的全部显示）
      if (modelTreeProp.spaceSwapStatus) {
        modelTreeProp.defaultCheckedKey = _.map(modelTreeProp.modelHideList, (el) => {
          return el.item
        })
      } else {
        modelTreeProp.hiddenNodeKeys = _.map(modelTreeProp.modelHideList, (el) => {
          return el.item
        })
      }
      cloudRender.Node.setItemStatus(player, rootItemsList, modelTreeProp.spaceSwapStatus)
      cloudRender.Node.setItemStatus(player, itemList, !modelTreeProp.spaceSwapStatus)
      modelTreeProp.spaceSwapStatus = !modelTreeProp.spaceSwapStatus

      modelTreeProp.filterItem = _.filter(modelTreeProp.filterItem, (el) => {
        return modelTreeProp.hiddenNodeKeys.indexOf(el) === -1
      })
      modelTreeProp.filterItem = [
        ...new Set([...modelTreeProp.filterItem, ...modelTreeProp.defaultCheckedKey]),
      ];
      [modelTreeProp.defaultCheckedKey, modelTreeProp.hiddenNodeKeys] = [
        modelTreeProp.hiddenNodeKeys,
        modelTreeProp.defaultCheckedKey,
      ]
      break
    case 'checkModelTree':
      // 模型树显隐操作: 1、根据勾选情况设置当前勾选项的显隐 2、设置默认框选中列表
      // 3、如果是显示: 查找当前项是否在隐藏列表中，如果有就去掉当前项以及其子孙节点，默认框选中列表中需要添加当前项，如果该项的其他兄弟节点都为选中状态，那么其父辈节点也就要添加进去
      // 4、如果是隐藏：将当前项添加到隐藏模型列表中去，默认框选中列表除去当前项以及其子孙节点，还包括其父辈节点
      cloudRender.Node.setItemStatus(player, selectInfo.item, isChecked)
      modelTreeProp.defaultCheckedKey = checkeds.checkedKeys
      if (isChecked) {
        const index = _.findIndex(modelTreeProp.modelHideList, ['item', selectInfo.item])
        if (index !== -1) {
          modelTreeProp.modelHideList.splice(index, 1)
        }
        const index1 = modelTreeProp.filterItem.indexOf(selectInfo.item)
        if (index1 !== -1) {
          // 重新设置选中
          modelTreeProp.filterItem.splice(modelTreeProp.filterItem.indexOf(selectInfo.item), 1)
        }
      } else {
        modelTreeProp.modelHideList.push(selectInfo)
        modelTreeProp.filterItem.push(selectInfo.item)
        // 获取选中的selectInfo的父级selfId
        let ParentInfo = await cloudRender.Node.getInfo(player, 'Item', selectInfo.parentItem)
        modelTreeProp.filterItem.push(ParentInfo.item)
        if (ParentInfo.selfId) {
          // 等于0则为最外面的一层
          while (ParentInfo.selfId !== 1) {
            ParentInfo = await cloudRender.Node.getInfo(player, 'Item', ParentInfo.parentItem)
            modelTreeProp.filterItem.push(ParentInfo.item)
          }
        }
        modelTreeProp.filterItem = [...new Set(modelTreeProp.filterItem)]
      }
      break
    case 'system.ToolShowSingle':
      // 孤立查看
      if (selectInfo.item) {
        if (modelTreeProp.spaceSwapStatus) {
          modelTreeProp.defaultCheckedKey = _.map(modelTreeProp.modelHideList, (el) => {
            return el.item
          })
        } else {
          modelTreeProp.modelHideList.push(selectInfo)
          modelTreeProp.filterItem.push(selectInfo.item)
          modelTreeProp.hiddenNodeKeys = _.map(modelTreeProp.modelHideList, (el) => {
            return el.item
          })
        }

        cloudRender.Node.setItemStatus(player, rootItemsList, modelTreeProp.spaceSwapStatus)
        cloudRender.Node.setItemStatus(player, selectInfo.item, true)
        modelTreeProp.spaceSwapStatus = !modelTreeProp.spaceSwapStatus

        modelTreeProp.filterItem = _.filter(modelTreeProp.filterItem, (el) => {
          return modelTreeProp.hiddenNodeKeys.indexOf(el) === -1
        })
        modelTreeProp.filterItem = [
          ...new Set([...modelTreeProp.filterItem, ...modelTreeProp.defaultCheckedKey]),
        ];
        [modelTreeProp.defaultCheckedKey, modelTreeProp.hiddenNodeKeys] = [
          modelTreeProp.hiddenNodeKeys,
          modelTreeProp.defaultCheckedKey,
        ]
      }
      break
    default:
      break
  }
}
export default setModelVisible
